// @flow
import * as React from 'react';
import type { ProtectedRouteProps } from './Router.types';
import NavBar from '../screens/NavBar';

const ProtectedRoute = ({ children }: ProtectedRouteProps) => (
  <React.Fragment>
    <NavBar />
    {children}
  </React.Fragment>
);

export default ProtectedRoute;
